import {
  CombinedTheme,
  isWeaveTheme,
  SupportedWeaveTheme,
} from '@adsk/alloy-react-styles';

import { IllustrationType, WeaveIllustrationType } from '../types';
import alloy from './alloy';
import weave from './weave';

const WEAVE_ILLUSTRATIONS = new Set<string>([
  'firstUse',
  'noChartData',
  'noData',
  'noPermission',
  'noResults',
  'systemError',
  'undergoingMaintenance',
  'fileUpload',
]);

const isWeaveIllustration = (
  illustration: IllustrationType,
): illustration is WeaveIllustrationType =>
  WEAVE_ILLUSTRATIONS.has(illustration);

export const getIllustration = (
  theme: CombinedTheme,
  illustration: IllustrationType,
): string | undefined => {
  if (isWeaveTheme(theme) && isWeaveIllustration(illustration)) {
    const colorMode = (theme.themeMetadata?.theme ??
      'light-gray') as SupportedWeaveTheme;
    const candidate = weave[illustration]?.[colorMode];

    if (!candidate) {
      console.error(`${illustration} not found weave/${colorMode} theme`);
    }

    return candidate;
  }

  const candidate = alloy[illustration];

  if (!candidate) {
    console.error(`${illustration} not found`);
  }

  return candidate;
};
